import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useConfiguratorContext } from '@grandvisionhq/configurator';

var RxStepWrapper = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    const { isFooterOpen  } = useConfiguratorContext();
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('step-wrapper', className, {
            'step-wrapper--summary-expanded': isFooterOpen
        })
    }, children);
};

export { RxStepWrapper };
//# sourceMappingURL=RxStepWrapper.js.map
